import { gql } from "@apollo/client";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { useResettableMutation } from "../useResettableMutation";
import { RemoveRoleFromPermitType, RemoveRoleFromPermitTypeVariables } from "./__generated__/RemoveRoleFromPermitType";

const REMOVE_ROLE_FROM_PERMIT_TYPE = gql`
  mutation RemoveRoleFromPermitType($organizationId: String!, $permitTypeId: String!, $orgRoleId: String!) {
    removeRoleFromPermitType(
      input: { organizationId: $organizationId, permitTypeId: $permitTypeId, orgRoleId: $orgRoleId }
    ) {
      success
    }
  }
`;

export function useRemoveRoleFromPermitType() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    RemoveRoleFromPermitType,
    RemoveRoleFromPermitTypeVariables
  >(REMOVE_ROLE_FROM_PERMIT_TYPE, { errorPolicy: "all" });

  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
